import React from 'react';
import DUILoading from '@tencent/dui/lib/components/Loading';
import i18n from '@i18next/i18n';
import Modal from '@tencent/dui/lib/components/Modal';
import { SlideContentList } from '@src/slide/application/service/slide-content-preview/core/view/slide-content-list';
import { IShowConfig } from '@src/slide/application/service/slide-content-preview/core/slide-content-preview.interface';

export class SlideContentPreviewService {
    public static instance: SlideContentPreviewService;

    public static getInstance(): SlideContentPreviewService {
        if (!this.instance) {
            this.instance = new SlideContentPreviewService();
        }
        return this.instance;
    }

    private modal;

    public show(config: IShowConfig) {
        const loading = DUILoading.show({ tip: i18n.t('正在生成预览结果...'), zIndex: 11001 });
        setTimeout(() => {
            this.modal = Modal.confirm({
                title: config.title || i18n.t('预览'),
                style: { width: 1060, height: 600 },
                onCancel: config.onCancel,
                content: <SlideContentList
                    originList={config.originList}
                    previewList={config.previewList}
                    slideWidth={config.slideWidth}
                    slideHeight={config.slideHeight}
                    originRects={config.originRects}
                    previewRects={config.previewRects}
                    slideIndexArray={config.slideIndexArray}
                    onConfirmButtonClick={(event) => {
                        this.modal?.close();
                        config.onConfirmButtonClick?.(event);
                    }}
                />,
                footer: () => {},
            });
            loading.close();
        }, 0);
    }

    public close() {
        this.modal.close();
    }
}
